import { useEffect, useState, useMemo } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Avatar from "../Tools/Avatar";
import { Link } from "react-router-dom";
import { Chip, Link as A, } from "@mui/material";
import HotIcon from '@mui/icons-material/Whatshot';
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import Grid from "../Tools/Grid";
import Search from '../Inputs/Search'
import useJsonStore from "../../services/Hooks/useJsonStore";
import moment from "moment/moment";

export default function Hots(){
    
    const columns = [
        {
            field: 'avatar',
            headerName: 'Fiche',
            width: 60,
            valueGetter: p => p.row.initials,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Link to={`/crm/persons/${p.id}`}>
                    <Avatar 
                        initials={p.row.initials} 
                        color={p.row.category?.color || 'grey'} 
                        size={36} 
                    />
                </Link>,
        },
        {
            field: 'firstName',
            headerName: 'Prénom',
            width: 100,
            valueGetter: p => p.row.firstName
        },
        {
            field: 'lastName',
            headerName: 'Nom',
            width: 150,
            valueGetter: p => p.row.lastName
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 250,
            valueGetter: p => p.row.email,
            renderCell: p => !p.row.isAutoGenerated &&
                <A href={`mailto:${p.row.email}`}>{p.row.email}</A>,
        },
        {
            field: 'phone',
            headerName: 'Téléphone',
            width: 160,
            valueGetter: p => p.row.phone,
            renderCell: p => !p.row.isAutoGenerated &&
                <A href={`tel:${p.row.phone}`}>{p.row.phone}</A>
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 150,
            valueGetter: p => p.row.category?.title
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 100,
            valueGetter: p => p.row.type?.title,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Chip label={p.row.type?.title} size='small'/>
        },
        {
            field: 'hot',
            headerName: 'Chaud',
            width: 60,
            type: 'boolean',
            valueGetter: p => p.row.hot,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <HotIcon 
                    color={p.row.hot ? 'warning' : 'disabled'} 
                    sx={{cursor: p.row.hot ? 'pointer' : 'default'}}
                    onClick={() => p.row.hot ? notHot(p.row.id) : null}
                />
        },
        {
            field: 'hotAt',
            headerName: 'Chaud à',
            type: 'date',
            width: 70,
            valueGetter: p => moment(p.row.hotEvent?.at).toDate(),
            renderCell: p => !p.row.isAutoGenerated &&
            moment(p.row.hotEvent?.at).format('HH:mm'),
        },
        {
            field: 'event',
            headerName: 'Événement',
            width: 250,
            valueGetter: p => p.row.hotEvent?.title,
        },
        {
            field: 'courses',
            headerName: 'Formations',
            type: 'number',
            valueGetter: p => p.row.enrollmentsCount || 0,
            width: 100,
        },
        {
            field: 'revenue',
            headerName: 'CA €',
            type: 'number',
            width: 100,
            valueGetter: p => p.row.revenue || 0,
        },
        {
            field: 'completion',
            headerName: 'Complétion %',
            type: 'number',
            width: 120,
            valueGetter: p => p.row.completion || 0,
        },
        {
            field: 'dutyMet',
            headerName: 'Obligation',
            width: 90,
            type: 'boolean',
            valueGetter: p => p.row.dutyMet,
            renderCell: p => !p.rowNode.isAutoGenerated &&
               (p.row.dutyMet ? 
                    <CheckIcon color='primary' size='small'/> : 
                    <UncheckIcon color='error' size='small'/>)
        },
        {
            field: 'status',
            headerName: 'Statut',
            width: 100,
            valueGetter: p => p.row.status?.title,
        },
        {
            field: 'rpps',
            headerName: 'RPPS',
            width: 150,
            valueGetter: p => p.row.rpps
        },
        {
            field: 'siret',
            headerName: 'SIRET',
            width: 150,
            valueGetter: p => p.row.siret
        },
        {
            field: 'workforce',
            headerName: 'Effectif',
            type: 'number',
            width: 80,
            valueGetter: p => p.row.workforce
        },
        {
            field: 'origin',
            headerName: 'Provenance',
            width: 150,
            valueGetter: p => p.row.origin?.title,
        },
        {
            field: 'subscription',
            headerName: 'Abonnement',
            width: 120,
            valueGetter: p => p.row.subscription?.title,
            renderCell: p => !p.rowNode.isAutoGenerated &&
                <Chip 
                    color={p.row.subscription?.id === 'none' ? 'default' : 'primary'} 
                    size='small' 
                    label={p.row.subscription?.title} 
                />
        },
        {
            field: 'lastActivity',
            headerName: 'Dernière activité',
            width: 90,
            type: 'date',
            valueGetter: p => p.row.lastActivity && moment(p.row.lastActivity).toDate(),
            renderCell: p => p.value ? moment(p.row.lastActivity).format('DD/MM/YYYY à HH:mm') : '',
        },
        {
            field: 'createdAt',
            headerName: 'Créé le',
            width: 90,
            type: 'date',
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated &&
                moment(p.row.createdAt).format('DD/MM/YYYY à HH:mm'),
        },
    ];

    const [persons, setPersons] = useState(null)
    const [search, setSearch] = useState('')
    const store = useJsonStore();
    

    useEffect(() => {

        const search = store.get('hotsSearch') || '';

        setSearch(search)

        API.get('/crm/users/hot')
            .then(r => setPersons(r.data))
            .catch(e => console.log(e.response?.data))


    }, [store])


    const rows = useMemo(() => {

        const match = p => (p.rpps + p.name + p.phone + p.email)
            .toLowerCase()
            .includes(search.toLowerCase())

        return persons ? persons.filter(p => match(p)) : null

    }, [persons, search])


    const notHot = id => {
        const old = [...persons];
        let copy = [...persons];
        let idx = copy.findIndex(p => p.id === id);
        let person = {...copy[idx], hot: false};
        copy[idx] = person;
        API.put(`/crm/users/${id}/not-hot`).catch(e => setPersons(old))
        return setPersons(copy);
    }

    const handleSearch = e => {
        const v = e.target.value;
        store.set('hotsSearch', v);
        setSearch(v);
    }

    return <Layout tab='hots' menu='crm' title='Utilisateurs chauds'>

        <Search
            value={search}
            onChange={handleSearch}
            sx={{mb: 1}}
        />

        <Grid 
            id='hotsGrid'
            columns={columns}
            rows={rows}
            toolbar
            aggregate={{
                revenue: 'sum', 
                completion: 'avg', 
                courses: 'sum'
            }}
        />

    </Layout>

}


